<h1>Terms and Conditions for MedPal</h1>
<p>Welcome to MedPal! These terms and conditions outline the rules and regulations for the use of the MedPal application.</p>

<h2>Acceptance of Terms</h2>
<p>By accessing or using MedPal, you accept and agree to be bound by these terms. If you do not agree, please do not use the application.</p>

<h2>License</h2>
<p>MedPal grants you a limited, non-exclusive, non-transferable license to access and use the application for personal and non-commercial purposes.</p>

<h2>User Obligations</h2>
<p>You agree to:</p>
<ul>
    <li>Provide accurate information during registration.</li>
    <li>Maintain the confidentiality of your account credentials.</li>
    <li>Notify us immediately of any unauthorized use of your account.</li>
    <li>Use the application in compliance with applicable laws and regulations.</li>
</ul>

<h2>Limitation of Liability</h2>
<p>MedPal is not liable for any indirect, incidental, or consequential damages arising from your use of the application. Use at your own risk.</p>

<h2>Modifications</h2>
<p>We reserve the right to modify these terms at any time. Changes will be posted on this page, and your continued use of the application constitutes acceptance of those changes.</p>

<h2>Contact Us</h2>
<p>If you have any questions about these terms, please contact us at <a href="mailto:info@medpal.app">info@medpal.app</a>.</p>
